// Ensure the precision is a number between 3 and 20
import {
  DEFAULT_DECIMAL_PRECISION,
  MAX_DECIMAL_PRECISION,
  MIN_DECIMAL_PRECISION
} from '@experiment-management-shared/constants/experimentGridConstants';

export function ensureValidDecimalsPrecision(
  decimalsPrecision: number | null | undefined
) {
  if (
    decimalsPrecision === null ||
    decimalsPrecision === undefined ||
    decimalsPrecision < MIN_DECIMAL_PRECISION ||
    decimalsPrecision > MAX_DECIMAL_PRECISION
  ) {
    return DEFAULT_DECIMAL_PRECISION;
  }
  return decimalsPrecision;
}
